import Axios from 'axios';
import {
  deleteVideoMutation,
  updateVideoMutation,
  createVideoMutation,
} from '@/api/video/graphql/video.mutations';
import { videoQuery, uploadVideoDoneQuery } from '@/api/video/graphql/video.queries';
import { IVideo } from '@/types/Video';
import { ICreateVideoDTO } from '@/api/video/dtos/create-video-dto';
import { apolloClient } from '@/apollo';
import { IVideoLibraryResponseDTO } from '@/api/video/dtos/video-library-response-dto';
import { EVideoSource } from '@/video/types/enums/video-source';
import { VideoHelper } from '@/video/helpers/video.helper';

export class VideoService {
  static async loadVideos(
    search: string = '',
    offset: number,
    limit: number,
    saved: boolean
  ): Promise<IVideoLibraryResponseDTO> {
    const {
      data: { videos },
    } = await apolloClient.query({
      query: videoQuery,
      variables: { search, offset, limit, saved },
      fetchPolicy: 'network-only',
    });
    return VideoHelper.correctDates(videos);
  }

  static async deleteVideo(id: string) {
    const { data } = await apolloClient.mutate({
      mutation: deleteVideoMutation,
      variables: { id },
    });
    return data;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  static async shareVideo(id: string) {
    return true;
  }

  static async updateVideo({ videoTitle, id }: { videoTitle: string; id: string }): Promise<void> {
    await apolloClient.mutate({
      mutation: updateVideoMutation,
      variables: { id, videoTitle },
    });
  }

  static async createVideo({
    videoTitle,
    published,
    saved,
    thumbUrl,
    videoUrl,
    videoType,
  }: ICreateVideoDTO): Promise<{ video: IVideo; uploadLink: string }> {
    const {
      data: { createVideo },
    } = await apolloClient.mutate({
      mutation: createVideoMutation,
      variables: {
        videoTitle,
        published,
        saved,
        thumbUrl,
        videoUrl,
        videoType,
      },
    });
    return createVideo;
  }

  static async createVideoLink(
    videoUrl: string,
    videoTitle: string,
    videoType: EVideoSource
  ): Promise<string> {
    const {
      data: { createVideo },
    } = await apolloClient.mutate({
      mutation: createVideoMutation,
      variables: {
        videoTitle,
        published: false,
        saved: false,
        videoUrl,
        videoType,
      },
    });
    return createVideo.video.id;
  }

  static async uploadVideo({
    file,
    uploadLink,
  }: {
    file: File;
    uploadLink: string;
  }): Promise<void> {
    await Axios.put(uploadLink, file);
  }

  static async uploadVideoDone(videoId: string): Promise<string> {
    const {
      data: {
        uploadVideoDone: { videoUrl },
      },
    } = await apolloClient.query({
      query: uploadVideoDoneQuery,
      variables: {
        videoId,
      },
    });
    return videoUrl;
  }
}
